import type { FaireProductEntity } from "../../entity_types/product";

export const p_2wxxgdt3yr: FaireProductEntity = {
  token: "p_2wxxgdt3yr",
  type: "product",
  name: "Hand Knit Wool Fleece Lined Booties Slipper Socks with Non Slip Soles (Canada)",
  brandToken: "b_15lckq7jwd",
  brandName: "Tibetan Socks",
  imageUrl:
    "https://cdn.faire.com/fastly/ec781d597a0552826d06325d2405ad2681e96994f4673ea911bbdf246d4c3e08.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d4dc6656666dd0405a8cafd75dd5c628675d5941b44dd46f933088eb1e106bf9.jpeg",
    "https://cdn.faire.com/fastly/ad6eb5b168e207c4c5b7c172d0372c03112598d1b09d7895dbfa4c714c578fe7.jpeg",
    "https://cdn.faire.com/fastly/bd16f09204a9ef130ded79efb770e6e48059147e573f7f0349c520a1ebd903a6.jpeg",
  ],
  priceDollars: 18.5,
  description:
    "High-quality, hand-made 100% pure wool slipper socks, lined in soft sherpa fleece with hand-stitched wool felt non-slip soles are the perfect for cozy feet at home. Tibetan Socks are unisex and designed for men, women, boys and girls.\n\n * \nHand-knit wool slipper socks, lined in soft fleece, featuring hand-stitched felt non-slip soles. These are the perfect slippers for cozy relaxing at home - easy to slip on and so comfortable you won’t want to take them off.\n\n * \nSUPERIOR CONSTRUCTION: Designed to fit snug on the leg without slipping. Knit from high quality New Zealand sheep wool. Non-skid bottoms provide traction on wood or stone floors.\n\n * \nCOMFORT: Completely lined in soft and silky sherpa fleece, these slippers are like a hug for your feet. They have extra cushioning from the felt sole and are designed to stay snug on your feet. \n\n * \nEXTRA WARM: Perfect for those with low blood circulation or just the curse of cold feet, putting these soft wool slippers between you and the floor will provide a toasty toes all winter long.\n\n * \nCOZY & COMPASSIONATE: Made in Himalayan villages by local housewives, this generations-old handicraft allows mothers to stay home with their children while earning supplemental income. Our socks are packaged in a gift-able cloth draw-string bag, perfect for sharing the warmth with loved ones.\n",
  tags: [],
  msrpDollars: 37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:28.694Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
